import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/frontru/aquaart-group/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/home/frontru/aquaart-group/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/frontru/aquaart-group/src/components/entities/header/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/frontru/aquaart-group/src/components/ui/info-blocks/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/frontru/aquaart-group/src/components/ui/container/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/frontru/aquaart-group/src/components/ui/info-blocks/block/index.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/frontru/aquaart-group/src/components/ui/info-blocks/rest-docs/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/frontru/aquaart-group/src/components/ui/title/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/frontru/aquaart-group/src/views/development/components/header/index.module.scss");
